import React from 'react'
import { EmailWrapper } from '../EmailWrapper'
import {
    Header,
    GeneralInfo,
    ClearanceCalc,
    DepartureOptions,
    Notes,
    getNotesForScenario,
    Graph,
    HighTidesTable,
    TidesAroundDeparture,
} from '../sections'

/**
 * Email template for latest_time calculation method (Scenario 1)
 * New format with DepartureOptions and Notes sections
 *
 * @param {object} props - Template props from prepareTemplateProps
 */
export const LatestTimeTemplate = props => {
    const {
        boatName,
        dockLabel,
        analysisDate,
        calculationMethod,
        alias,
        boatDraft,
        tolerance,
        dockDepth,
        minTide,
        endManoeuverHour,
        image,
        departureOptions,
        highTides,
        tidesAroundDeparture,
    } = props

    return (
        <EmailWrapper>
            <Header boatName={boatName} dockLabel={dockLabel} />

            <GeneralInfo
                boatName={boatName}
                dockLabel={dockLabel}
                analysisDate={analysisDate}
                calculationMethod={calculationMethod}
                alias={alias}
            />

            <ClearanceCalc
                boatDraft={boatDraft}
                tolerance={tolerance}
                dockDepth={dockDepth}
                dockLabel={dockLabel}
                minTide={minTide}
            />

            <DepartureOptions
                calculationMethod={calculationMethod}
                departureOptions={departureOptions}
            />

            <Graph image={image} />
            <br />

            <Notes noteNumbers={getNotesForScenario(calculationMethod, false, dockLabel)} />

            {/* TODO: Remove after PDF attachment validation - tide tables now in Marees-Tides.pdf */}
            {/* <HighTidesTable tides={highTides} /> */}
            {/* <TidesAroundDeparture tides={tidesAroundDeparture} departureTime={endManoeuverHour} /> */}
        </EmailWrapper>
    )
}
